import { createApp } from "vue";
import App from "./App.vue";

import "vfonts/FiraCode.css";
import "vfonts/Lato.css";

const app = createApp(App);

app.mount("#app");
